// Consignments page specific translations - English
export const consignmentsEn = {
  hero: {
    title: 'Consignment',
    description:
      'Consign your vehicle with us and maximize your return. We handle the entire sales process.',
  },
  form: {
    firstName: 'First name',
    lastName: 'Last name',
    email: 'Email',
    phone: 'Phone',
    brand: 'Brand',
    brandPlaceholder: 'Select a brand',
    model: 'Model',
    modelPlaceholder: 'Select a model',
    year: 'Year',
    mileage: 'Mileage',
    condition: 'Vehicle Condition',
    message: 'Additional details',
    submit: 'Submit Request',
  },
  info: {
    advantagesTitle: 'Advantages of Consigning with Us',
    benefitsTitle: 'Consignment benefits',
    benefitsList: {
      item1: 'Maximize your vehicle’s sale value',
      item2: 'No need to handle the sales process',
      item3: 'Broad exposure to potential buyers',
      item4: 'Avoid complex paperwork and procedures',
    },
    processTitle: 'Consignment process',
    processList: {
      step1: 'Vehicle assessment and appraisal',
      step2: 'Consignment contract signing',
      step3: 'Showcasing and promotion',
      step4: 'Offer management and negotiations',
      step5: 'Fast payment once sold',
    },
    directContactTitle: 'Direct Contact',
    emailLabel: 'Email',
    phoneLabel: 'Phone',
  },
  embed: {
    infoTitle: 'How does it work?',
    steps: [
      { title: 'Send your info', desc: 'Fill out the form with your vehicle details.' },
      { title: 'Evaluation', desc: 'Our team evaluates your vehicle and contacts you.' },
      { title: 'Listing', desc: 'We list your vehicle on multiple platforms.' },
      { title: 'Sale', desc: 'We manage the entire process until closing the sale.' },
    ],
    benefitsTitle: 'Benefits',
    benefits: ['Listed on multiple platforms', 'Full sale management', 'Best price guaranteed'],
  },
};

